import script from "./invoice-details-customer.vue?vue&type=script&setup=true&lang=js"
export * from "./invoice-details-customer.vue?vue&type=script&setup=true&lang=js"

import "./invoice-details-customer.vue?vue&type=style&index=0&id=23854dd3&lang=css"

const __exports__ = script;

export default __exports__